import dayjs from "dayjs";

export const DISPLAY_DATE_FORMAT = "DD-MM-YYYY";

const ISO_DATE = /^\d{4}[-/]\d{2}[-/]\d{2}([T ].*)?$/;
// "due_date", "created_at", "dateOfBirth" match; "candidate_submit" nahi
const DATE_KEY = /(^|_)date($|_)|_at$|Date$/;

const looksLikeDate = (key: string, value: unknown): boolean => {
  if (value instanceof Date) return true;
  if (typeof value === "string" && ISO_DATE.test(value)) return true;
  if (DATE_KEY.test(key)) {
    if (typeof value === "number") return true;
    if (typeof value === "string" && /\D/.test(value) && value.length >= 8)
      return true;
  }
  return false;
};

export const toSearchText = (value: unknown, key = ""): string => {
  if (value === null || value === undefined) return "";

  if (Array.isArray(value)) {
    return value.map((v) => toSearchText(v, key)).join(" ");
  }

  if (typeof value === "object" && !(value instanceof Date)) {
    const o = value as Record<string, any>;
    return String(o.original_name ?? o.file_name ?? o.name ?? "");
  }

  if (looksLikeDate(key, value)) {
    const d = dayjs(value as any);
    if (d.isValid()) return d.format(DISPLAY_DATE_FORMAT);
  }
  return String(value);
};

export const filterByColumnSearch = <T extends Record<string, any>>(
  rows: T[],
  columnSearch: Record<string, string>,
  getters: Record<string, (row: T) => string> = {},
): T[] => {
  const active = Object.entries(columnSearch).filter(([, v]) => v?.trim());
  if (!active.length) return rows;

  return rows.filter((row) =>
    active.every(([key, term]) => {
      const text = getters[key]
        ? getters[key](row)
        : toSearchText(row[key], key);
      return text.toLowerCase().includes(term.trim().toLowerCase());
    }),
  );
}

// import dayjs from "dayjs";

// export const DISPLAY_DATE_FORMAT = "DD-MM-YYYY";

// const ISO_DATE = /^\d{4}[-/]\d{2}[-/]\d{2}([T ].*)?$/;
// const DATE_KEY = /date/i;

// const looksLikeDate = (key: string, value: unknown): boolean => {
//   if (value instanceof Date) return true;
//   if (typeof value === "string" && ISO_DATE.test(value)) return true;
//   if (DATE_KEY.test(key)) {
//     if (typeof value === "number") return true;
//     if (typeof value === "string" && /\D/.test(value) && value.length >= 8) return true;
//   }
//   return false;
// };

// export const toSearchText = (value: unknown, key = ""): string => {
//   console.log("toSearchText called", key, value); // temporary, remove later
//   if (value === null || value === undefined) return "";
//   if (looksLikeDate(key, value)) {
//     const d = dayjs(value as any);
//     if (d.isValid()) return d.format(DISPLAY_DATE_FORMAT);
//   }
//   return String(value);
// };
// export const filterByColumnSearch = <T extends Record<string, any>>(
//   rows: T[],
//   columnSearch: Record<string, string>,
//   getters: Record<string, (row: T) => string> = {},
// ): T[] => {
//   const active = Object.entries(columnSearch).filter(([, v]) => v?.trim());
//   if (!active.length) return rows;

//   const result = rows.filter((row) =>
//     active.every(([key, term]) => {
//       const text = getters[key] ? getters[key](row) : toSearchText(row[key], key);
//       return text.toLowerCase().includes(term.trim().toLowerCase());
//     }),
//   );

//   console.log("FILTER RESULT", JSON.stringify(active), "in:", rows.length, "out:", result.length);
//   return result;
// };

